import axios from 'axios';

/*
*  This file contains all axios calls related to "create order" goal operations
*/

const BASE_CREATE_ORDER_URL = '/app/createOrderFunnel';
const BASE_CREATE_PRODUCT_URL = '/app/createOrderFunnelProduct';

export const loadCreateOrderConfig = async (createOrderConfigId) => {
    const { data } = await axios.get(`${BASE_CREATE_ORDER_URL}/createOrder/${createOrderConfigId}`);

    return data;
};

export const createOrderConfig = async () => {
    try {
        const { data } = await axios.post(`${BASE_CREATE_ORDER_URL}/createOrder`);

        return data;
    } catch (error) {
        throw new Error('Could not create order config.');
    }
};

export const updateCreateOrderConfig = async (createOrderConfigId, payload) => {
    try {
        const { data } = await axios.put(`${BASE_CREATE_ORDER_URL}/orders/${createOrderConfigId}`, payload);

        return data;
    } catch (error) {
        throw new Error('Could not update CreateOrderConfig.');
    }
};

export const saveCreateOrderConfigAsReady = async (createOrderConfigId, payload) => {
    try {
        const { data } = await axios.put(`${BASE_CREATE_ORDER_URL}/orders/${createOrderConfigId}/ready`, payload);

        return data;
    } catch (error) {
        throw new Error('Could not save CreateOrderConfig As Ready.');
    }
};

export const loadProductAndSubscriptionList = async () => {
    const { data } = await axios.get(`${BASE_CREATE_ORDER_URL}/getProductAndSubscriptionList`);

    return data;
};

export const createProduct = async (payload) => {
    try {
        const { data } = await axios.post(`${BASE_CREATE_PRODUCT_URL}/addProduct`, {
            productName: payload.name,
            productType: payload.productType,
            productDescription: payload.shortDesc,
            productPrice: payload.price,
            subscriptionBillEvery: payload.billEvery,
            subscriptionAmountOfCycles: payload.amountOfCycles,
            subscriptionPlanPrice: payload.planPrice,
            subscriptionPlanCycle: payload.planCycle,
            addAsType: payload.addAs,
        });

        return data;
    } catch (error) {
        throw new Error('Could not create product.');
    }
};

export const createOrderItem = async (createOrderConfigId, productId, type) => {
    try {
        const { data } = await axios.post(`${BASE_CREATE_ORDER_URL}/orders/${createOrderConfigId}/${type}/${productId}`);

        return data;
    } catch (error) {
        throw new Error('Could not create product item.');
    }
};

export const saveOrderItem = async (createOrderConfigId, productId, type, payload) => {
    try {
        const { data } = await axios.put(`${BASE_CREATE_ORDER_URL}/orders/${createOrderConfigId}/${type}/${productId}`, payload);

        return data;
    } catch (error) {
        throw new Error('Could not save product item.');
    }
};

export const deleteOrderItem = async (orderItemId) => {
    try {
        const { data } = await axios.delete(`${BASE_CREATE_ORDER_URL}/items/${orderItemId}`);

        return data;
    } catch (error) {
        throw new Error('Could not delete product item.');
    }
};
